export const ICONS = {
  linkedin: "https://cdn-icons-png.flaticon.com/24/174/174857.png",
  phone: "https://i.postimg.cc/SN3tSSmB/phone.png",
  location: "https://i.postimg.cc/CMvQ2CXL/location.png",
  website: "https://i.postimg.cc/XqvDJXGb/internet.png",
  facebook: "https://i.postimg.cc/9FrnHRHP/facebook.png",
  linkedinCompany: "https://i.postimg.cc/gjBt6d86/linkedin.png",
  banner: "https://i.postimg.cc/Hx23MMFN/inspiria.png",
  outlook: "https://img.icons8.com/color/96/microsoft-outlook-2019.png"
};

export const INSPIRIA_LOGO_BG = "https://i.postimg.cc/Hx23MMFN/inspiria.png";
